import { Skills } from '@air/api';

type SkillsCreateParams = NonNullable<Parameters<typeof Skills.create>[0]>;
type SkillsListParams = NonNullable<Parameters<typeof Skills.list>[0]>;

/** Canvas skill list/create calls always send `type: 'canvas'`. */
export const skillsCreateWithCanvasType = (params: Omit<SkillsCreateParams, 'type'>) =>
  Skills.create({ ...params, type: 'canvas' });

export const skillsListWithCanvasType = (params: Omit<SkillsListParams, 'type'> & { type?: 'canvas' }) =>
  Skills.list({ ...params, type: params.type ?? 'canvas' });
